import { render } from "./WohnungStep1.vue?vue&type=template&id=527188ba&scoped=true"
import script from "./WohnungStep1.vue?vue&type=script&lang=js"
export * from "./WohnungStep1.vue?vue&type=script&lang=js"

import "./WohnungStep1.vue?vue&type=style&index=0&id=527188ba&scoped=true&lang=css"

import exportComponent from "/Users/a98ca8a/projects/immo-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527188ba"]])

export default __exports__